{
  "title": "Glibness",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level transmutation",
  "level": 8,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V",
  "duration": "1 hour",
  "description": [
    "Until the spell ends, when you make a Charisma check, you can replace the number you roll with a 15. Additionally, no matter what you say, magic that would determine if you are telling the truth indicates that you are being truthful."
  ],
  "spellLists": ["bard", "warlock"]
}
